/* these should not both be set to true at any given time */
export const showLiveStreamTeaser    = false
export const showLiveStream          = false
export const showLinkToLiveRecording = false
